import Cookies from 'js-cookie';
import renderComponentFromEl from '~/javascripts/utils/renderComponentFromEl';
import { unmountComponentAtNode } from 'react-dom';

document.addEventListener('alpine:init', () => {
  Alpine.store('modal', { current: '' });

  window.addEventListener('hashchange', () => {
    Alpine.store('modal').current = window.location.hash.slice(1);
  });
});

export default (id, config) => ({
  show: false,
  modalId: id,
  childComponentEls: [],
  scrollPosition: 0,
  bodyMarginTop: '',
  init: function () {
    if (window.location.hash === `#${this.modalId}` || config.autoOpen) {
      this.open();
    }

    if (!config.disableHistory) {
      this.$watch('$store.modal.current', (value) => {
        if (value === this.modalId) {
          this.open();
        } else if (value !== this.modalId) {
          this.close();
        }
      });
    }
  },
  open: function () {
    if (this.show) return;

    this.show = true;

    if (!config.disableHistory) {
      window.location.hash = `#${this.modalId}`;
      this.$store.modal.current = this.modalId;
    }

    this.persistScrollPositionAndLockBody();
    this.track();
    this.renderChildComponents();
    this.fireOpenEvent();
  },
  close: function () {
    if (!this.show) return;

    this.show = false;

    if (!config.disableHistory && this.$store.modal.current === this.modalId) {
      this.$store.modal.current = '';
      window.location.hash = '';
    }

    this.restoreScrollPositionAndUnlockBody();
    this.unmountChildComponents();
  },
  maybeClose: function () {
    if (config.explicitClose) return;

    this.close();
  },
  track: function () {
    const trackingInfo = {
      ...{
        name: this.modalId,
        label: this.modalId,
        utm: Cookies.get('maji_utm'),
      },
      ...config.trackingInfo,
    };

    window.track_event('Viewed Modal', trackingInfo);
  },
  fireOpenEvent: function () {
    this.$nextTick(() => {
      document.dispatchEvent(
        new CustomEvent('ModalOpened', {
          detail: {
            modalId: this.modalId,
          },
        })
      );
    });
  },
  renderChildComponents: function () {
    this.$nextTick(() => {
      Array.from(this.$refs.inner.querySelectorAll('[data-component]')).forEach(
        (el) => {
          this.childComponentEls.push(el);
          renderComponentFromEl(el);
        }
      );
    });
  },
  unmountChildComponents: function () {
    this.childComponentEls.forEach((el) => {
      unmountComponentAtNode(el);
    });
  },
  persistScrollPositionAndLockBody: function () {
    this.scrollPosition = window.scrollY;
    this.bodyMarginTop = getComputedStyle(document.body).marginTop;
    document.body.classList.add('modal-open');
    document.body.style.marginTop = `-${this.scrollPosition}px`;
  },
  restoreScrollPositionAndUnlockBody: function () {
    document.body.classList.remove('modal-open');
    document.body.style.marginTop = this.bodyMarginTop;
    window.scrollTo(0, this.scrollPosition);
  },
});
